<template>
  <!-- 内容管理详情页 -->
  <div class="contentDetail" @touchstart="touchStart" @touchend="touchEnd">
    <HeadTitle :url="url"></HeadTitle>
    <!-- <HeadTopContent :headTitle="$route.meta.title"></HeadTopContent> -->
    <div style="margin: 100px 0px 60px 0px">
      <header class="header">
        <div>审核PID:{{ auditID }}</div>
        <div>帖子:{{ postNum }}条</div>
        <div class="btnRow">
          <van-button @click="previous" plain type="info" :disabled="disabledOne">上一条</van-button>
        </div>
        <div class="btnRow">
          <van-button @click="next" plain type="info" :disabled="disabledTwo">下一条</van-button>
        </div>
      </header>
      <main>
        <div class="box" v-for="item in allList" :key="item.id">
          <div class="topRow">
            <div class="topRowLeft">
              <div>
                <img class="touXiangImg" :src="item.image" mode="" @click="selectUserList(item.uid)" />
              </div>
              <div class="headLeft">
                <div class="name">
                  {{ item.name }}
                </div>
                <div>
                  <div class="car">
                    {{ item.car }}
                  </div>
                </div>
              </div>
            </div>
            <div class="topRowRight" :style="{ 'color': caseFieldColorValue(item.state) }">{{ item.state }}</div>
          </div>

          <div v-for="(item, index) in item.imgArr" :key="index">
            <div v-if="item.msg_type === 'text'">
              <div class="content" v-for="(item_text, item_index) in item.msg_content" :key="item_index">
                {{ item_text.content }}
              </div>
            </div>
            <div v-if="item.msg_type === 'img'">
              <img class="imageBox contentBoxImg" :src="item.msg_content" alt="描述" srcset=""
                @click="showImg(item.msg_content)" />
            </div>
            <div v-if="item.msg_type === 'video'">
              <video class="videoBox contentBox" controls :src="item.msg_content"></video>
            </div>
            <!-- <img class="imageBox" :src="item.imageBox1" alt="" srcset="" /> -->
          </div>

          <div class="timeBox">
            <div class="operation">
              <div>
                <img src="../../assets/icon/yan-jing.png" alt="" class="listFooterRightImg" /><span
                  class="listFooterRightNum">
                  {{ item.num1 }}
                </span>
              </div>
              <div>
                <img src="../../assets/icon/xin-xi.png" alt="" class="listFooterRightImg" /><span
                  class="listFooterRightNum"> {{ item.num2 }}</span>
              </div>
              <div>
                <img src="../../assets/icon/xin-xi.png" alt="" class="listFooterRightImg" /><span
                  class="listFooterRightNum"> {{ item.num3 }}</span>
              </div>
            </div>

            <div class="time" @click="showInfoDetail = true">
              {{ item.time }} <van-icon name="arrow" />
            </div>
          </div>
        </div>
      </main>
      <footer class="commFooter" style="height: 100%">
        <!-- <van-list> -->

        <div class="replyBox">
          <van-divider content-position="left"
            :style="{ color: 'black', fontWeight: '600', fontSize: '0.42667rem', borderColor: 'black' }">
            {{ listData.length }}条评论
          </van-divider>
        </div>
        <div v-if="listData.length === 0" class="van-empty">
          <div class="van-empty__image"><img src="../../assets/icon/empty-image-default.png"></div>
          <p class="van-empty__description">暂无评论</p>
        </div>
        <div v-if="listData.length > 0">
          <div class="box" v-for="item in listData" :key="item.id">
            <div class="topRow" @touchstart="start(item)" @touchend="end">
              <div class="topRowLeft">
                <div class="headLeft">
                  <div>
                    <span class="name_pl">{{ item.author }}</span> :
                    <span> {{ item.content }}</span>
                  </div>
                  <div>
                    <div class="dateTime">{{ item.date }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="reply">
              <div class="topRow" v-for="item_reply in item.list" :key="item_reply.id" @touchstart="start(item_reply)"
                @touchend="end">
                <div class="topRowLeft">
                  <div class="headLeft">
                    <div>
                      <span class="name_pl">{{ item_reply.author }}</span> :
                      <span> {{ item_reply.content }}</span>
                    </div>
                    <div>
                      <div class="dateTime">{{ item_reply.date }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </van-list> -->
      </footer>
    </div>
    <div class="btnBoottom">
      <div class="operationBtn">
        <div @click="bantInit(item.title)" class="btn1" v-for="(item, index) in btnList" :key="index">
          {{ item.title }}
        </div>
      </div>
    </div>
    <!-- 详细信息的弹框 -->
    <van-dialog v-model="showInfoDetail" :showConfirmButton="false">
      <div class="InfoDetailBox">
        <h4>详细信息</h4>
        <div class="infoBox" v-for="(item, index) in detailList" :key="index">
          <span>{{ item.title }}</span><span class="infoValue">{{ item.value }}</span>
        </div>
        <div>
          <van-button round block @click="showInfoDetail = false" style="
                                          background: rgb(72, 113, 192);
                                          color: white;
                                          margin-top: 20px;
                                        ">确定</van-button>
        </div>
      </div>
    </van-dialog>
    <!-- 评论的底部弹框 -->
    <van-popup v-model="showPopup" position="bottom" round :style="{ height: '40%' }">
      <div class="commonPop">
        <div class="titleTop">管理员评论</div>
        <van-field label="PGC账号" readonly v-model="circle" is-link @focus="showCircle = true"
          style="font-size: 16px"></van-field>
        <van-action-sheet v-model="showCircle" :round="false" :actions="selectList" @select="onSelect"></van-action-sheet>
        <van-field v-model="textMess" rows="6" autosize label="评论" type="textarea" placeholder="请输入评论文字内容(最多5000字)" />
        <div class="btnRow">
          <van-button type="default" block hairline round style="
                                          width: 150px;
                                          color: rgb(72, 113, 192);
                                          border: 1px solid rgb(72, 113, 192);
                                        " @click="cancelCircle">取消</van-button>
          <van-button block hairline round style="width: 150px; background: rgb(72, 113, 192); color: white"
            @click="oKCircle">确认</van-button>
        </div>
      </div>
    </van-popup>

    <!-- show-cancel-button -->
    <van-dialog v-model="showEdit" title="编辑圈子" confirmButtonText="保存" confirmButtonColor="#1699d2" theme="round-button"
      :closeOnClickOverlay="true" :style="{ height: '25%' }" @confirm="confirmEdit">
      <van-field label="圈子列表:" v-model="circle" is-link @focus="showCircle = true"></van-field>
      <van-action-sheet v-model="showCircle" :round="false" :actions="selectList" @select="onSelect"></van-action-sheet>
      <!-- <van-dropdown-menu>
        <van-dropdown-item v-model="value1" :options="option1" />
      </van-dropdown-menu> -->
    </van-dialog>
  </div>
</template>
<script>
import { Dialog, Toast, ImagePreview } from "vant";
import HeadTitle from "../../components/HeadTitle";
// import HeadTopContent from "./components/HeadTopContent";
import {
  addCommentListAPI,
  deleteCommentListAPI,
  doauditAPI,
  getarticledetailAPI,
  listAPI,
  setRecommendAPI,
  showCommentListAPI,
  editforumAPI,
  pushWorkOrderAPI,
} from "@/api/contentManagement";
export default {
  name: "ContentManageDetail",
  components: {
    HeadTitle,
    // HeadTopContent,
  },
  data() {
    return {
      url: "/contentManage",
      auditID: this.$route.query.pid,
      postNum: "0",
      showInfoDetail: false,
      allList: [
        {
          image: require("../../assets/icon/katong1.png"),
          name: "表哥1",
          car: "迪趣杂谈",
          content:
            "比亚迪e1用电枪发的发生发撒官方萨嘎撒打发范德萨共发放犯得上发生",
          time: "2022-08-26 06：17",
          id: "",
          state: "通过",
          imgArr: [],
          num1: 0,
          num2: 0,
          num3: 0,
          auditOperatePre: "",
          auditOperateNext: "",
          uid: "",
        },
      ],
      listData: [],
      detailList: [
        { title: "评论数", value: "0" },
        { title: "点赞数", value: "0" },
        { title: "查看数", value: "0" },
        { title: "发帖地理位置", value: "" },
        { title: "发帖经纬度", value: "0" },
        { title: "发表时间", value: "" },
        { title: "创建时间", value: "" },
        { title: "更新时间", value: "" },
      ],
      state: "review", // 通过当前状态控制下方按钮的显示隐藏，review表示当前为审核中，pass表示通过，noPass表示没有通过
      showEdit: false,
      circle: "",
      selectList: [],
      pgcId: "",
      showCircle: false,
      showPopup: false,
      delta: 50,
      textMess: "",
      touchStartX: 0, // 触屏起始点x
      disabledOne: true,
      disabledTwo: true,
      btnList: [],
    };
  },
  created() {
    this.onLoad(this.getParams());
    let selectList = JSON.parse(localStorage.getItem("pgcList"));
    if (selectList.length > 0) {
      this.circle = selectList[0].name;
      this.pgcId = selectList[0].value;
      this.selectList = JSON.parse(localStorage.getItem("pgcList"));
    }
  },
  methods: {
    caseFieldColorValue(state) {
      const stateList = {
        "审核通过": "rgb(0, 193, 0)",
        "待审核": "#d6d62f",
      };
      return stateList[state] ? stateList[state] : "red";
    },
    selectUserList(uid) {
      console.log(uid);
      // this.$router.push({ path: "/contentManage", query: { pathId: uid } });
    },
    start(item) {
      clearTimeout(this.loop); //再次清空定时器，防止重复注册定时器
      this.loop = setTimeout(() => {
        this.deleteComment(item);
      }, 1000);
    },
    end() {
      clearTimeout(this.loop); //清空定时器，防止重复注册定时器
    },
    getParams() {
      let params = this.$route.query.params;
      let postParams = { pid: this.auditID };
      for (var key in params) {
        postParams["condition[" + key + "]"] = params[key];
      }
      return postParams;
    },
    loadCommentList(pid) {
      this.listData = [];
      Toast.loading({ message: "加载中...", forbidClick: true });
      showCommentListAPI({ pid: pid })
        .then((res) => {
          if (res.status === 200) {
            res.data.map((item) => {
              this.listData.push({
                image: item.img,
                author: item.author,
                content: item.content,
                date: item.date,
                id: item.id,
                list: item.list,
              });
            });
          }
        })
        .finally(() => {
          Toast.clear();
        });
    },
    loadData(dataRes, pid) {
      listAPI({ pid: pid }).then((res) => {
        if (res.data.code === 0) {
          if (res.data.data.length > 0) {
            let data = res.data.data[0];
            this.auditID = data.pid;
            this.allList[0].id = data.pid;
            this.allList[0].image = data.img;
            this.allList[0].name = data.author;
            this.allList[0].car = data.fname;
            this.allList[0].time = data.dateline;
            this.allList[0].num1 = data.comments;
            this.allList[0].num2 = data.praises;
            this.allList[0].num3 = data.views;
            this.allList[0].uid = data.authorid;
            this.detailList[0].value = data.comments;
            this.detailList[1].value = data.praises;
            this.detailList[2].value = data.views;
            this.detailList[3].value = data.location;
            this.detailList[4].value = data.lon + "/" + data.lat;
            this.detailList[5].value = data.dateline;
            this.detailList[6].value = data.t_crt_time;
            this.detailList[7].value = data.t_upt_time;
            this.batLoad(dataRes, data.fname);
          }
        }
      });
    },
    batLoad(item, fname) {
      this.btnList = [];
      this.btnList.push({ title: "评论" });
      this.btnList.push({ title: item.actionBar.createOrder.title });
      if (fname != "投诉专区") {
        this.btnList.push({ title: "投诉专区" });
      } else {
        this.btnList.push({ title: "已投诉" });
      }
      if (item.statusBar.status.title == "审核通过" && item.actionBar.createOrder.title != "已创单") {
        this.btnList.push({ title: item.actionBar.recommend.title });
      }
      if (item.statusBar.status.title != "审核通过") {
        this.btnList.push({ title: "通过" });
      }
      if (item.statusBar.status.title != "审核不通过") {
        this.btnList.push({ title: "不通过" });
      }
    },
    onLoad(params) {
      getarticledetailAPI(params).then((res) => {
        if (res.data.code === 1) {
          let data = res.data.data;
          this.postNum = data.auditCount.auditTotalCount;
          this.allList[0].state = data.operateData.statusBar.status.title;
          this.allList[0].imgArr = data.messList;
          this.allList[0].auditOperatePre = data.auditCount.auditOperatePre;
          this.allList[0].auditOperateNext = data.auditCount.auditOperateNext;
          if (data.auditCount.auditOperatePre == "") {
            this.disabledOne = false;
          } else {
            this.disabledOne = true;
          }
          if (data.auditCount.auditOperateNext == "") {
            this.disabledTwo = false;
          } else {
            this.disabledTwo = true;
          }
          this.loadData(data.operateData, data.pid);
          this.loadCommentList(data.pid);
        }
        Toast.clear();
      });
    },
    touchStart(e) {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    },
    touchEnd(e) {
      let deltaX = e.changedTouches[0].clientX - this.touchStartX;
      let deltaY = e.changedTouches[0].clientY - this.touchStartY;
      // X轴的滑动距离大于 delta，且此次事件是以X轴移动为主（左滑或者右滑）；
      if (
        Math.abs(deltaX) > this.delta &&
        Math.abs(deltaX) > Math.abs(deltaY)
      ) {
        if (deltaX >= 0) {
          this.previous();
          console.log("右滑上一条");
        } else {
          this.next();
          console.log("左滑下一条");
        }
      }
    },
    onCopy(item) {
      navigator.clipboard.writeText(item).then(() => {
        Toast.success("复制成功");
      });
    },
    bantInit(title) {
      if (title == "评论") {
        this.showPopup = true;
      }
      if (title == "创单") {
        this.createSingle();
      }
      if (title == "投诉专区") {
        this.complaint();
      }
      if (title == "推荐") {
        this.recommend(1);
      }
      if (title == "取消推荐") {
        this.recommend(0);
      }
      if (title == "通过") {
        this.pass();
      }
      if (title == "不通过") {
        this.fail();
      }
    },
    // 创单
    createSingle() {
      Dialog.confirm({
        title: "创建工单",
        message: `你确定将pid：${this.auditID}创建工单吗？`,
      })
        .then(() => {
          let data = { pid: this.auditID, is_push: 1 };
          pushWorkOrderAPI(data, data).then((res) => {
            if (res.data.code === 1) {
              Toast.success(res.data.msg);
              this.onLoad(this.getParams());
            }
          });
        })
        .catch(() => { });
    },
    // 投诉专区
    complaint() {
      Dialog.confirm({
        title: "投诉",
        message: "你确定要投诉吗?",
        // theme: "round-button",
      })
        .then(() => {
          editforumAPI({ pid: this.auditID, fid: 235, invisible: 1 }).then(
            (res) => {
              if (res.data.status === 1) {
                Toast.success(res.data.info);
                this.onLoad(this.getParams());
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
      // this.showEdit = true;
    },
    // 不通过
    fail() {
      Dialog.confirm({
        title: "操作",
        message: "是否确认不通过该内容?",
      })
        .then(() => {
          this.state = "noPass";
          doauditAPI({ pid: this.auditID, invisible: -3 }).then((res) => {
            if (res.data.code === 1) {
              Toast.success(res.data.msg);
              this.onLoad(this.getParams());
            }
          });
        })
        .catch(() => { });
    },
    //删除评论
    deleteComment(item) {
      Dialog.confirm({
        title: "操作",
        message: "是否将 [" + item.author + ":" + item.content + "] 评论删除？",
      })
        .then(() => {
          let data = { pid: this.auditID, "delete[0]": item.id };
          let params = { pid: this.auditID };
          deleteCommentListAPI(data, params).then((res) => {
            Toast.success(res.data.info);
            this.loadCommentList(this.auditID);
          });
        })
        .catch(() => { });
    },
    onSelect(item) {
      this.showCircle = false;
      this.circle = item.name;
      this.pgcId = item.value;
    },
    // 通过
    pass() {
      Dialog.confirm({
        title: "操作",
        message: "是否确认通过该内容?",
      })
        .then(() => {
          this.state = "pass";
          doauditAPI({ pid: this.auditID, invisible: 1 }).then((res) => {
            if (res.data.code === 1) {
              Toast.success(res.data.msg);
              this.onLoad(this.getParams());
            }
          });
        })
        .catch(() => { });
    },
    delComment() {
      Dialog.confirm({
        title: "操作",
        message: "你确定要删除该评论吗?",
        // theme: "round-button",
      })
        .then(() => {
          // on close
          Toast.success("删除成功");
        })
        .catch(() => {
          // on cancel
        });
    },
    cancelCircle() {
      this.showPopup = false;
      this.textMess = "";
    },
    oKCircle() {
      const data = {
        pid: this.auditID,
        comment_authorid: this.pgcId,
        comment_content: this.textMess,
      };
      if (data.comment_authorid == "") {
        Toast.fail("请选择PCG账号！");
        return;
      }
      if (data.comment_content == "") {
        Toast.fail("请输入评论内容！");
        return;
      }
      addCommentListAPI(data, { pid: this.auditID }).then((res) => {
        if (res.data.status === 1) {
          Toast.success(res.data.info);
          this.cancelCircle();
          this.loadCommentList(this.auditID);
        } else {
          Toast.fail(res.data.info);
        }
      });
    },
    // 推荐-取消推荐
    recommend(isrecommend) {
      let title = "";
      if (isrecommend === 1) {
        title = "推荐";
      } else {
        title = "取消推荐";
      }
      let data = { pid: this.auditID, isrecommend: isrecommend };
      Dialog.confirm({
        title: "操作",
        message: "是否" + title + "该内容?",
      })
        .then(() => {
          this.state = "pass";
          setRecommendAPI(data, data).then((res) => {
            if (res.data.status === 1) {
              Toast.success(res.data.info);
              this.onLoad(this.getParams());
            }
          });
        })
        .catch(() => { });
    },
    // 编辑圈子的确认
    confirmEdit() {
      console.log(this.circle, "推荐的圈子列表");
      Toast.success("编辑圈子成功");
    },
    // 上一条
    previous() {
      if (this.allList[0].auditOperatePre == "") {
        Toast.loading({ message: "数据更新中...", forbidClick: true });
        let params = this.getParams();
        params.type = "pre";
        this.onLoad(params);
      }
    },
    // 下一条
    next() {
      if (this.allList[0].auditOperateNext == "") {
        Toast.loading({ message: "数据更新中...", forbidClick: true });
        let params = this.getParams();
        params.type = "next";
        this.onLoad(params);
      }
    },
    showImg(img) {
      ImagePreview({ "images": [img], showIndex: false })
    },
  },
};
</script>
<style scoped lang="less">
.contentDetail {
  width: 100%;
  height: 100%;
  min-height: 1200px;

  // margin: 20px 0px;
  .header {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 20px 0px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    margin: 100px 0px 0px;
    background-color: white;
    padding: 5px 0 5px 0px;
    z-index: 999;

    div {
      font-size: 26px;
      color: #1699d2;
    }

    .btnRow {
      button {
        width: 160px;
        height: 60px;
        border-radius: 15px;
        line-height: 60px;
        background: white;
        color: #1699d2;
        border: 1px solid #1699d2;
      }
    }
  }

  .box {
    padding: 0px 30px;
    margin: 32px 0px;
    border-bottom: 2px solid #ececec;
    font-size: 26px;

    .uid {
      color: #969799;
      margin-top: 10px;
    }

    .dateTime {
      color: #969799;
      margin-top: 5px;
    }
  }

  .reply {
    margin-left: 90px;
    margin-bottom: 20px;
    border-left: 1px solid #c7c5c5;

    .topRow {
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .headLeft {
      margin-left: 8px !important;
    }

    .uid {
      color: #969799;
    }
  }

  .topRow {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .topRowLeft {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .touXiangImg {
        width: 80px;
        height: 80px;
        border-radius: 50%;
      }

      .headLeft {
        margin-left: 30px;

        .name {
          font-weight: 500;
          font-size: 32px;
        }

        .name_pl {
          color: #eb7350;
        }

        .car {
          padding: 0px 12px;
          color: #b77d43;
          background-color: #f4f0e4;
          height: 40px;
          font-size: 26px;
          text-align: center;
          margin-top: 8px;
          line-height: 40px;
          max-width: 180px;
          overflow: hidden;
        }
      }
    }

    .topRowRight {
      color: red;
      font-size: 26px;
      margin-top: 10px;
    }
  }

  .content {
    font-size: 30px;
    color: #969799;
    margin: 12px 0px;
  }

  .contentBox {
    display: block;
    width: 100%;
    height: 500px;
    background-size: contain;
    margin-bottom: 10px;
  }

  .contentBoxImg {
    display: block;
    width: 100%;
    height: 100%;
    background-size: contain;
    margin-bottom: 10px;
  }

  .timeBox {
    display: flex;
    justify-content: space-between;
    height: 80px;
    align-items: center;
    font-size: 26px;
    color: #969799;

    .operation {
      display: flex;
      justify-content: flex-end;

      div {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 16px;

        .listFooterRightImg {
          width: 50px;
          height: 50px;
        }

        .listFooterRightNum {
          display: inline-block;
          margin-left: 8px;
          height: 50px;
          line-height: 50px;
        }
      }
    }
  }

  // .listBox {
  //   /deep/.van-cell__title {
  //     font-size: 32px;
  //     color: black;
  //     font-weight: 500;
  //   }
  // }
  .btnBoottom {
    position: fixed;
    left: 0px;
    right: 0px;
    bottom: 10px;
    z-index: 5;
    width: 100%;
    height: 80px;

    .operationBtn {
      display: flex;
      line-height: 80px;
      justify-content: space-around;

      div {
        font-size: 30px;
        width: 24%;
        text-align: center;
        border: 1px solid rgb(72, 113, 192);
        margin: 0px 12px;
      }

      .btn1 {
        background: #4871c0;
        color: white;
        border-radius: 15px;
      }

      .btn2 {
        background: rgb(72, 113, 192);
        color: white;
      }
    }
  }

  .commonPop {
    .titleTop {
      height: 120px;
      line-height: 120px;
      font-size: 40px;
      text-align: center;
    }

    .text {
      width: 100%;
      height: 40px;
      display: flex;

      span {
        margin-left: 20px;
        font-size: 32px;
      }
    }

    .btnRow {
      display: flex;
      justify-content: space-around;
      margin-top: 8px;
    }
  }

  .replyBox {
    width: 100%;
    height: 30px;
    font-size: 32px;

    span {
      margin-left: 32px;
      font-weight: 600;
    }
  }

  .InfoDetailBox {
    margin: 20px;

    h4 {
      text-align: center;
    }

    .infoBox {
      height: 60px;
      line-height: 60px;
      font-size: 20px;
      color: #969799;

      .infoValue {
        margin-left: 8px;
      }
    }
  }
}
</style>